import React, { useEffect, useState } from "react";
import { Paper, Typography, Tabs, Tab,  Box, Divider  } from "@mui/material";
import httpClient from '../../_util/api'
import AttachmentsList from "../../components/AttachmentList";
import Timeline from "./TimeLine";

const NotesComponent = ({ data }) => {
  return (
    <Paper sx={{ padding: 3, borderRadius: 2, boxShadow: 3 }}>
      <Typography variant="h6" gutterBottom>
        Notes
      </Typography>

      {data.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No notes available.
        </Typography>
      ) : (
        data.map((user, index) => (
          <Box key={user.id || index} sx={{ mb: 2 }}>
            <Typography variant="body1" sx={{ mb: 0.5 }}>
              {user.remarks}
            </Typography>
            {index !== data.length - 1 && <Divider />}
          </Box>
        ))
      )}
    </Paper>
  );
};

const ApplicationDetails = ({ data }) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [timelines, setTimelines] = useState([]);
  const getTimelines = async () => {
      const res = await httpClient.get(`/timelines/getTimelines/${data.applicationNumber}`);
      if (res?.status === 200) {
        setTimelines(res?.data)
      }
  }
  useEffect(()=> {
    getTimelines();
  }, [])

  return (
    <div>
      <Tabs value={tabIndex} onChange={(e, newIndex) => setTabIndex(newIndex)} sx={{ marginBottom: 2 }}>
        <Tab label="Status" />
        <Tab label="Attachments" />
        <Tab label="Notes" />
      </Tabs>
      {tabIndex === 0 && <Timeline data={timelines} id={data.applicationNumber}/>}
      {tabIndex === 1 && <AttachmentsList data={data}/>}
      {tabIndex === 2 && <NotesComponent data={data.notes}/>}
    </div>
  );
};

export default ApplicationDetails;